import React, { FC, useEffect, useState } from 'react';
import {
  faFilter,
  faList,
  faPager,
  faSort,
  faSortDown,
  faSortUp,
  faTableList,
  faTag,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

interface SorterProps {
  onChange: (sorter: any) => void;
}

const OphirSorter: FC<SorterProps> = (props) => {

  const [t] = useTranslation() as unknown as [(key: string) => string];
  const [shortView, setShortView] = useState(false);
  const [sorter, setSorter] = useState<any>({ by: 'none', order: 'none' });

  useEffect(() => {
    if (!localStorage.getItem('shortViewoph')) {
      localStorage.setItem('shortViewoph', 'true');
    }
    if (localStorage.getItem('shortViewoph') === 'true') {
      document.querySelector('.package-list.results-list')?.classList.add('oph-short');
      setShortView(true);
    }
  }, []);

  const onChange = (by: 'name' | 'price') => {
    let newSorter: object;
    if (sorter.order === 'none' || sorter.by !== by) {
      newSorter = { by, order: 'asc' };
    } else if (sorter.order === 'asc' && sorter.by === by) {
      newSorter = { by, order: 'desc' };
    } else {
      newSorter = { by, order: 'asc' };
    }

    setSorter(newSorter);
    props.onChange(newSorter);
  };

  const getSorterIcon = (by: 'name' | 'price') => {
    if (sorter.by === by && sorter.order === 'asc') {
      return faSortUp;
    } else if (sorter.by === by && sorter.order === 'desc') {
      return faSortDown;
    } else {
      return faSort;
    }
  };

  const toggleCardsListView = () => {
    if (shortView) {
      setShortView(false);
      document.querySelector('.package-list.results-list')?.classList.remove('oph-short');
      localStorage.setItem('shortViewoph', 'false');
    } else {
      setShortView(true);
      document.querySelector('.package-list.results-list')?.classList.add('oph-short');
      localStorage.setItem('shortViewoph', 'true');
    }
  };

  const toggleFilter = () =>
    document.querySelector('.oph-filter')?.classList.toggle('oph-filter-open');

  return (
    <div className="oph-sorting">
      <div className="oph-sorting-item">
        <div className="oph-sorting-filter" onClick={toggleFilter}>
          <FontAwesomeIcon icon={faFilter as any} />
          <span>{t('filter')}</span>
        </div>
        {shortView ? (
          <div className="oph-sorting-switcher" onClick={toggleCardsListView}>
            <FontAwesomeIcon icon={faPager as any} />
            <span>{t('tour.display_in_cards')}</span>
          </div>
        ) : (
          <div className="oph-sorting-switcher" onClick={toggleCardsListView}>
            <FontAwesomeIcon icon={faTableList as any} />
            <span>{t('tour.display_in_list')}</span>
          </div>
        )}
      </div>
      <div className="oph-sorting-item oph-sorting-sorter" onClick={() => onChange('price')}>
        <FontAwesomeIcon icon={faTag as any} />
        <span>{t('price')}</span>
        <FontAwesomeIcon icon={getSorterIcon('price') as any} />
      </div>
      <div className="oph-sorting-item oph-sorting-sorter" onClick={() => onChange('name')}>
        <FontAwesomeIcon icon={faList as any} />
        <span>{t('name')}</span>
        <FontAwesomeIcon icon={getSorterIcon('name') as any} />
      </div>
    </div>
  );
};

export default OphirSorter;
